import { TypeMotsClef } from '../../../../formulaires/divers/diversAttribution/models/TypeMotsClef';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step8 } from '../../../../shared/models/component-messages/blocCommun/divers/step8';
@Component({
  selector: 'app-type-mots-clef',
  templateUrl: './type-mots-clef.component.html'
})
export class TypeMotsClefComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeMotsClef';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() motsClef: TypeMotsClef;
  public infobulle = '';

  public step8 = new Step8();

  constructor(private translateService: TranslateService) {}

  public ngOnInit() {
    this.infobulle = this.translateService.instant("eform-editable.infobulle.mots-descripteurs");
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

}

